import {
  ASSET_TYPE_LIST, ASSET_TYPE_LIST_SUCCESS, ASSET_TYPE_LIST_FAILURE,
  ASSET_TYPE_DATA, ASSET_TYPE_DATA_SUCCESS, ASSET_TYPE_DATA_FAILURE,
  ASSET_TYPE_CREATE, ASSET_TYPE_CREATE_SUCCESS, ASSET_TYPE_CREATE_FAILURE,
  ASSET_TYPE_UPDATE, ASSET_TYPE_UPDATE_SUCCESS, ASSET_TYPE_UPDATE_FAILURE,
  ASSET_TYPE_DELETE, ASSET_TYPE_DELETE_SUCCESS, ASSET_TYPE_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  assetTypeList: [], assetTypeListLoading: false, assetTypeListError: null,
  assetTypeData: [], assetTypeDataLoading: false, assetTypeDataError: null,
  assetTypeCreate: [], assetTypeCreateLoading: false, assetTypeCreateError: null,
  assetTypeUpdate: [], assetTypeUpdateLoading: false, assetTypeUpdateError: null,
  assetTypeDelete: [], assetTypeDeleteLoading: false, assetTypeDeleteError: null,
};

const AssetType = (state = initialState, action) => {
  switch (action.type) {
    case ASSET_TYPE_LIST:         return { ...state, assetTypeListLoading: true, assetTypeListError: null };
    case ASSET_TYPE_LIST_SUCCESS: return { ...state, assetTypeList: action.payload, assetTypeListLoading: false, assetTypeListError: null };
    case ASSET_TYPE_LIST_FAILURE: return { ...state, assetTypeList: [], assetTypeListLoading: false, assetTypeListError: action.payload };

    case ASSET_TYPE_DATA:         return { ...state, assetTypeDataLoading: true, assetTypeDataError: null };
    case ASSET_TYPE_DATA_SUCCESS: return { ...state, assetTypeData: action.payload, assetTypeDataLoading: false, assetTypeDataError: null };
    case ASSET_TYPE_DATA_FAILURE: return { ...state, assetTypeData: [], assetTypeDataLoading: false, assetTypeDataError: action.payload };

    case ASSET_TYPE_CREATE:         return { ...state, assetTypeCreateLoading: true, assetTypeCreateError: null };
    case ASSET_TYPE_CREATE_SUCCESS: return { ...state, assetTypeCreate: action.payload, assetTypeCreateLoading: false, assetTypeCreateError: null };
    case ASSET_TYPE_CREATE_FAILURE: return { ...state, assetTypeCreate: [], assetTypeCreateLoading: false, assetTypeCreateError: action.payload };

    case ASSET_TYPE_UPDATE:         return { ...state, assetTypeUpdateLoading: true, assetTypeUpdateError: null };
    case ASSET_TYPE_UPDATE_SUCCESS: return { ...state, assetTypeUpdate: action.payload, assetTypeUpdateLoading: false, assetTypeUpdateError: null };
    case ASSET_TYPE_UPDATE_FAILURE: return { ...state, assetTypeUpdate: [], assetTypeUpdateLoading: false, assetTypeUpdateError: action.payload };

    case ASSET_TYPE_DELETE:         return { ...state, assetTypeDeleteLoading: true, assetTypeDeleteError: null };
    case ASSET_TYPE_DELETE_SUCCESS: return { ...state, assetTypeDelete: action.payload, assetTypeDeleteLoading: false, assetTypeDeleteError: null };
    case ASSET_TYPE_DELETE_FAILURE: return { ...state, assetTypeDelete: [], assetTypeDeleteLoading: false, assetTypeDeleteError: action.payload };

    default: return state;
  }
};

export default AssetType;
